import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-xl-12 stretch-card" }
const _hoisted_3 = { class: "row flex-grow-1" }
const _hoisted_4 = { class: "col-md-4 grid-margin stretch-card" }
const _hoisted_5 = { class: "card card-total" }
const _hoisted_6 = { class: "card-body text-center card-body-primary" }
const _hoisted_7 = { class: "card-h6" }
const _hoisted_8 = { class: "card-h3" }
const _hoisted_9 = { class: "col-md-4 grid-margin stretch-card" }
const _hoisted_10 = { class: "card card-total" }
const _hoisted_11 = { class: "card-body text-center card-body-secondary" }
const _hoisted_12 = { class: "card-h6" }
const _hoisted_13 = { class: "card-h3" }
const _hoisted_14 = { class: "col-md-4 grid-margin stretch-card" }
const _hoisted_15 = { class: "card card-total" }
const _hoisted_16 = { class: "card-body text-center card-body-tertiary" }
const _hoisted_17 = { class: "card-h6" }
const _hoisted_18 = { class: "card-h3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.i18n.t('tables.cashflow.encaissements')), 1),
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.totalEncaissements?.toFixed(2) ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h6", _hoisted_12, _toDisplayString(_ctx.i18n.t('tables.cashflow.decaissements')), 1),
              _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.totalDecaissements?.toFixed(2) ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h6", _hoisted_17, _toDisplayString(_ctx.i18n.t('tables.cashflow.cashflow')), 1),
              _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.totalCashflow?.toFixed(2) ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}